import { useState } from "react"
import { Button, Modal, TextArea } from "semantic-ui-react"
import { sysAPI } from "../../../../apis/SysAPI"
import { useDispatch } from "react-redux"
import { setSnackbar } from "../../../../actions/snackbar.actions"
import { responseError } from "../../../../helpers"

const ButtonReport = ({taxYear, client}) => {
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')

    const handlerReport = async () => {
        setLoading(true)
        try {
            const {data} = await sysAPI.post(`/report/manual-input/${client}/fulltax`, {
                message: message,
                taxYear: taxYear
            })

            dispatch(setSnackbar({message: data.message || "Manual inputed reported!"}))
            setOpenModal(false)
        } catch (error) {
            console.error({error})
            responseError(error, undefined, "ButtonReport.handlerReport", dispatch)
        }
        setLoading(false)
    }

    return <>
        <Button onClick={() => setOpenModal(!openModal)} color="purple">Report</Button>

        <Modal open={openModal} onOpen={() => setOpenModal(true)} onClose={() => setOpenModal(false)}>
            <Modal.Header>
                Report this tax
            </Modal.Header>
            <Modal.Content>
                <div>
                    <TextArea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Write your comment"
                        style={{width:'100%'}}
                    />
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                <Button onClick={() => handlerReport()} loading={loading}>Submit</Button>
            </Modal.Actions>
        </Modal>
    </>
}

export default ButtonReport